/**
 * ============================================================================
 *  SITE CONFIGURATION
 * ----------------------------------------------------------------------------
 *  Edit the values below to rebrand this template. These are the main knobs
 *  used across the app (header, footer, SEO, contact, payment page, etc.).
 * ============================================================================
 */

export const siteConfig = {
  brand: {
    name: 'Flash USDT Website',
    tagline: 'Flash USDT Website — Secure, Fast, Reliable',
    description:
      'Flash USDT Website is the licensed flash USDT software for TRC-20, ERC-20 and BEP-20. Flash up to $10,000,000 USDT daily with our secure, tradable, swappable, and transferable flash USDT solution.',
  },

  domain: 'https://flashusdt.website',

  contact: {
    orderEmail: 'buyflashusdtsoftware@gmail.com',
    supportEmail: 'buyflashusdtsoftware@gmail.com',
    whatsapp: '447514003077',
    phoneDisplay: '+44 7514 003077',
  },

  social: {
    twitter: 'https://twitter.com/yourbrand',
    facebook: 'https://facebook.com/yourbrand',
    instagram: 'https://instagram.com/yourbrand',
    telegram: 'https://t.me/yourbrand',
  },

  payment: {
    wallets: {
      bitcoin: 'bc1qlw4lcq87ue7l4tgn3m3j4ax7q2287hn5jgefqt',
      usdt: 'TNudmjRuhw29EMfVn7RHf2uEf8Lw9ePRFF',
    },
  },
};

export default siteConfig;
